import Hero from "@/pages/home/Hero";
import TrustStrip from "@/pages/home/TrustStrip";
import Intro from "@/pages/home/Intro";
import Services from "@/pages/home/Services";
import Capacity from "@/pages/home/Capacity";
import Capabilities from "@/pages/home/Capabilities";
import CanadaOps from "@/pages/home/CanadaOps";
import FinalCta from "@/pages/home/FinalCta";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Home() {
  usePageMeta({
    title: "30 NORTH | Transportation & Logistics",
    description:
      "30 NORTH provides reliable transportation and logistics solutions for businesses across Canada, with flexible options built around your freight requirements.",
    path: "/",
  });

  return (
    <div data-testid="home-page">
      <Hero />
      <TrustStrip />
      <Intro />
      <Services />
      <Capacity />
      <Capabilities />
      <CanadaOps />
      <FinalCta />
    </div>
  );
}
